import styled from 'styled-components';

export const AlbumItemCardHeader = styled.div`
  background: var(--grey-200);
  color: var(--grey-800);
  padding: 0.3125rem 0.625rem;
  border-bottom: 1px solid var(--grey-300);
  font-size: 12px;
  line-height: 16px;
  width: 100%;
  display: flex;

  p {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  button {
    width: 14px;
    height: 14px;
    border-radius: 2px;
    padding: 0;
  }
`;

export const AlbumItemCard = styled.a`
  width: 13.125rem !important;
  height: 13.125rem !important;
  border-radius: 2px !important;
  padding: 0 !important;
  background: #fff;
  border: 1px solid var(--grey-300);
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: auto !important;

  &.hasPhoto {
    cursor: pointer !important;
  }

  &:hover {
    text-decoration: none;
  }
`;

export const AlbumItemCardBody = styled.div`
  flex: 1;
  padding: 0.375rem 0.5rem;
  width: calc(100% - 16px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const AlbumItemCardImage = styled.div`
  flex: 1;
  aspect-ratio: 25 / 16;
  width: 100%;
  height: 151px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .emptystate-message {
    margin: 0;
  }
`;

export const AlbumItemCardFooter = styled.div`
  color: var(--grey-900);
  font-size: 12px;
  line-height: 17px;
  width: 100%;
  padding: 0.3125rem 0.625rem;
`;
